import React, { Component } from 'react'
import LeftPane from './LeftPane'
import RightPane from './RightPane'
import BuildItemType from '../BuildItemType'
import './style.css'

class Body extends Component {
  state = {
    selectedBuildItemType: BuildItemType.BOT
  }

  onBuildItemSelected = (selectedBuildItemType) => {
    this.setState({ selectedBuildItemType })
  }

  render() {
    const { selectedBuildItemType } = this.state
    return (
      <div className="home-body">
        <div className="home-body-panes">
          <span className="home-body-panes-back-text">
            Get building
          </span>
          <LeftPane
            selectedBuildItemType={selectedBuildItemType}
            onBuildItemSelected={this.onBuildItemSelected}
          />
          <RightPane selectedBuildItemType={selectedBuildItemType} />
        </div>
      </div>
    )
  }
}

export default Body
